import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { LanguageSelector, Row } from './';
import { useTranslation } from 'react-i18next';

const StyledNav = styled.nav`
  background: transparent;
  position: sticky;
  color: #ec1c24;
  top: 0;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 90px;
  z-index: 1;

  img {
    max-width: 50px;
  }

  p {
    font-weight: 900;
    font-size: 25px;
    margin: -5px 0 0 10px;
  }


  @media (max-width: 768px) {
    position: fixed;
    width: 100%;
    padding: 0 20px;
    p {
     display: none;
    }
  }
`

const Link = styled.button`
  background: transparent;
  padding: 0;
  border: 0 none;
  color: ${({ active }) => (active ? '#ec1c24' : '#363535')};
  font-weight: 500;
  margin-right: 25px;
  font-size: 17px;
  transition: color 0.3s;
  min-width: 150px;

  &:hover {
    color: #ED6F8D
  }

  @media (max-width: 768px) {
    display: none;
  }
`


const Nav = () => {
  const [active, setActive] = useState(null);
  const { t } = useTranslation();

  const links = [
    { label: t('navBar.About'), id: 'summary' },
    { label: t('navBar.WhyWinner'), id: 'whyWinner' },
    { label: t('navBar.Products'), id: 'products' },
    { label: t('navBar.Contact'), id: 'contact' },
  ];

  const handleLinkClick = (i, id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActive(i);
    }
  };

  const handleScroll = () => {
    links.forEach((link, i) => {
      const element = document.getElementById(link.id);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top > 0 && rect.top <= 100) {
          setActive(i);
        }
      }
    });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setActive(null);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledNav>
      <Row between center wid='100%'>
        <Row gap='8px' center onClick={scrollToTop} style={{ cursor: 'pointer' }}>
          <div>
            <img src={require('assets/logo.jpg')} alt="Logo" />
          </div>
          <p>Winner Balkans</p>
        </Row>
        <Row marg='0 0 0 auto' center>
          {links.map((link, i) => (
            <Row>
              <Link
                key={i}
                active={active === i}
                onClick={() => handleLinkClick(i, link.id)}
              >
                {link.label}
              </Link>
           </Row>
          ))}
           <LanguageSelector />
        </Row>
     
       
      </Row>
    </StyledNav>
  );
};

export default Nav;
